/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastactivity1Inputs */

const de__field_lastactivity1 = /** @type {(inputs: _Field_Lastactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Aktivität am`)
};

/**

* @param {_Field_Lastactivity1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastactivity1 = /** @type {((inputs?: _Field_Lastactivity1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastactivity1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lastactivity1(inputs)
});
export { _field_lastactivity1 as "_field_lastActivity" }